export default __webpack_public_path__ + "img/c425b986408d4c2dab29851a07e84afd.gif";